import React from "react";
import './content.css'

const HTMLContent = ({body, isMain, toc, title}) => {
  const nestedContent = ( items ) => {
    return items.map((content) => {
      return (
        <>
          <h3>
            {content.title}
          </h3>
          <div key={content.id} id={`bookmark_${content.id}`} dangerouslySetInnerHTML={{__html: content.content}}/>
          {content.children ? nestedContent(content.children) : null}
        </>
      )
    })
  }
  return (
    <>
      {isMain ? (
        <div  dangerouslySetInnerHTML={{__html: body}}/>
      ) : (
        <>
          <div className="content">
            {nestedContent(toc)}
          </div>
        </>

      )}
    </>
  )
}


export default HTMLContent
